import React from 'react';
import config from '@/config';
import { STATE_KEY } from '@/common/constant';
import { createState } from '@/common/utils';

export default function Login() {
  const redirectToLoginPage = () => {
    const host = window.location.origin;
    const { ssoUrl, client_id } = config;
    const state = createState();
    localStorage.setItem(STATE_KEY, state);
    const redirectURL = encodeURIComponent(`${host}/auth/redirect`);
    const loginHref = `${ssoUrl}/oauth2/auth?redirect_uri=${redirectURL}&approval_prompt=auto&client_id=${client_id}&state=${state}&response_type=code`;
    window.location.href = loginHref;
  };

  redirectToLoginPage();

  return <div />;
}
